/**
 * Skip-to-content link for keyboard/screen reader users (WCAG 2.4.1)
 */
export const SkipToContent = () => (
  <a
    href="#main-content"
    className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-lg focus:shadow-lg focus:outline-none"
  >
    Skip to main content
  </a>
);
